import esLocale from '@fullcalendar/core/locales/es'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import FullCalendar from '@fullcalendar/react'
import rrulePlugin from '@fullcalendar/rrule'
import timeGridPlugin from '@fullcalendar/timegrid'
import {useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {CLEANING_SCHEDULE_SERVICES} from '../../../../services'
import {colors} from 'react-select/dist/declarations/src/theme'

const mapDays = {
  LU: 'mo',
  MA: 'tu',
  MI: 'we',
  JU: 'th',
  VI: 'fr',
  SA: 'sa',
  DO: 'su',
}

const calculateDuration = (start: string, end: string) => {
  const [sh, sm] = start.split(':').map(Number)
  const [eh, em] = end.split(':').map(Number)

  const startMinutes = sh * 60 + sm
  const endMinutes = eh * 60 + em

  const diffMinutes = endMinutes - startMinutes

  const hours = Math.floor(diffMinutes / 60)
  const minutes = diffMinutes % 60

  return `${hours}:${minutes.toString().padStart(2, '0')}`
}

const CalendarCleaningSchedule = () => {
  const {currentTabItem} = useLimpieza()
  const [events, setEvents] = useState<any[]>([])
  const WORK_END = '18:00'

  const getDataById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (!idToEdit) return

      const {
        data: {data},
      } = await CLEANING_SCHEDULE_SERVICES.getByIdCleaningSchedule(idToEdit)

      if (!data) return
      const response = data

      const dias = response.DiasSeleccionado
        ? response.DiasSeleccionado.split('-').map((d: string) => mapDays[d])
        : []

      const startDate = response.FechaInicio.split('T')[0]
      const startDateTime = `${startDate}T${response.HoraInicio}`

      const rrule: any = {
        dtstart: startDateTime,
        interval: response.CantidadRepeticion || 1,
      }

      if (response.FechaFin) {
        rrule.until = `${response.FechaFin.split('T')[0]}T23:59:59`
      }

      switch (response.TipoRepeticion) {
        case 'DIARIO':
          rrule.freq = 'daily'
          break

        case 'SEMANAL':
          rrule.freq = 'weekly'
          if (dias.length) {
            rrule.byweekday = dias
          }
          break

        case 'MENSUAL':
          rrule.freq = 'monthly'
          break

        case 'ANUAL':
          rrule.freq = 'yearly'
          break
      }

      const duration = calculateDuration(response.HoraInicio.slice(0, 5), WORK_END)

      const event = {
        title: response.Nomenclatura,
        rrule,
        duration: duration,
        extendedProps: {
          campamento: response.Campamento,
          tipo: response.TipoEdificacion,
          hora: response.HoraInicio,
        },
      }

      setEvents([event])
    } catch (error) {
      console.error('Error fetching schedule data:', error)
    }
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getDataById()
    }
  }, [currentTabItem.idToEdit])

  return (
    <KTCard className=''>
      <div className='py-12 px-6 h-full'>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin]}
          initialView='dayGridMonth'
          events={events}
          locale={esLocale}
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay',
          }}
          height='auto'
          eventTimeFormat={{
            hour: 'numeric',
            minute: '2-digit',
            meridiem: 'short',
          }}
        />
      </div>
    </KTCard>
  )
}

export default CalendarCleaningSchedule
